import { render, staticRenderFns } from "./PercentileForm.vue?vue&type=template&id=73250ec8"
import script from "./PercentileForm.vue?vue&type=script&lang=js"
export * from "./PercentileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports